<app-external-page>
    <div 
        class="error-container" 
        fxLayoutAlign="center center"
        content-container>
        <div fxFlex="500px" fxFlex.xs="100%" fxLayoutAlign="center center">
            <div fxLayout="row" fxLayoutGap="30px" fxLayoutGap.lt-md="20px">
                <fa-icon icon="exclamation-circle"></fa-icon>
                
                <div fxLayout="column" fxLayoutGap="20px" fxLayoutGap.lt-md="16px">
                    <div class="mat-display-2">Ooops,</div>
                    <span class="mat-subheading-2">
                        Houve um erro inesperado! Por favor, entre em contato
                        com nossa equipe de suporte e tente novamente.
                    </span>
                </div>
            </div>
        </div>
    </div>
</app-external-page>